module.exports = __webpack_public_path__ + "static/media/missing-render@2x.ca38a6cb.png";